<template>
    <div class="step-heading__container">
        <h2 class="step-heading">
            <span v-if="currentStep.pills"
                >Step {{ currentStep.pills.item }} of
                {{ currentStep.pills.total }} - </span
            >{{ currentStep.label }}
        </h2>
        <div class="step-bar">
            <span
                v-for="(step, index) in currentStep.pills.total"
                :key="index"
                class="step-bar__step"
                :class="{
                    'step-bar__step--active': index === currentStep.pills.item - 1,
                }"
            ></span>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    name: "Navigation",
    computed: {
        ...mapState(["navigator"]),
        ...mapGetters(["currentStep"]),
    },
};
</script>

<style lang="scss" scoped>
.step-bar {
    display: flex;
    gap: 15px;

    &__step {
        flex: 1;
        height: 4px;
        background-color: #d1d1d1;
        border-radius: 16px;

        &--active {
            background-color: #0093d6;
        }
    }
}

.step-heading {
    margin: 0;
    font-size: 15px;
    color: #0093d6;
    font-weight: 600;
    margin-bottom: 12px;

    &__container {
        margin-top: 37px;
    }
}
</style>
